



















import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Action } from "vuex-class";

import FlowMixin from "@/mixins/flow";

import { ActionSelectSection } from "@/store/flow/actions/";
import { CSSProperties, ISection } from "@/index.d";

type SelectSection = (payload: ActionSelectSection) => void;

@Component
export default class Background extends mixins(FlowMixin) {
  @Action("flow/selectSection") private selectSection!: SelectSection;

  private getStyles(styles: CSSProperties) {
    return { height: styles.height };
  }

  private onMouseEnter(index: number) {
    this.moveOnSection(index);
  }

  private onMouseLeave() {
    this.moveOutSection();
  }

  private onBackgroundClick(section: ISection, index: number) {
    this.selectSection({ section, index });
  }
}
